import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from "@mui/material";
import HeaderPattern from "../Components/Common/HeaderPattern";
import './Styles/LavoraConNoiStyles.css';
import { ApplicationModal } from "../Components/JobModal/JobModal.js";
import { ConfirmationModal } from "../Components/JobModal/ConfirmModal.js";
const redGradient = "linear-gradient(90deg, #e3764c 0%, #99191b 100%)";

// Map i18n keys to backend role identifiers (kept in Italian for backend compatibility)
const ROLE_ENTRIES = [
    { key: "careers.roles.internship", apiValue: "TIROCINIO" },
    { key: "careers.roles.architect", apiValue: "ARCHITETTO" },
    { key: "careers.roles.electricalDesigner", apiValue: "PROGETTISTA IMP. ELETTRICI" },
    { key: "careers.roles.mechanicalDesigner", apiValue: "PROGETTISTA IMP. MECCANICI" },
];

export const JoinUs = () => {
    const pageRef = useRef(null);
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState("");
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handleOpenModal = (apiValue) => {
        setSelectedRole(apiValue);
        setModalOpen(true);
    };
    const handleCloseModal = () => setModalOpen(false);

    const handleSubmitApplication = () => {
        setModalOpen(false);
        setShowConfirmation(true);
    };
    const handleCloseConfirmation = () => setShowConfirmation(false);

    return (
        <div ref={pageRef}>
            {/* Hero section – identical to FinanzaDiProgetto */}
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
                {/* Spacer top */}
                <Box sx={{ height: { xs: 40, sm: 80, md: 150 } }} />

                {/* HEADER */}
                <Box
                    className="esi-transition-header"
                    sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        borderTop: "2px solid #fff",
                        borderBottom: "2px solid #fff",
                        background: redGradient,
                        overflow: "hidden",
                        py: "1.2rem",
                    }}
                >
                    <Box
                        sx={{
                            flex: { xs: "0 0 35%", sm: "0 0 45%", md: "0 0 55%" },
                            display: { xs: "none", sm: "flex" },
                            alignItems: "center",
                            justifyContent: "flex-start",
                            height: "100%",
                        }}
                    >
                        <HeaderPattern
                            className="lavora-header-lines"
                            style={{
                                width: "100%",
                                height: "300px",
                                maxHeight: "300px",
                                overflow: "visible",
                                transform: "scale(1.3) translateX(-10%)",
                                transformOrigin: "left center",
                                userSelect: "none",
                                pointerEvents: "none",
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: { xs: "center", sm: "flex-end" },
                            justifyContent: "center",
                            paddingRight: { xs: "16px", sm: "calc(max(24px, (100vw - 1400px) / 2 + 24px))" },
                            pl: { xs: 2, sm: 0 },
                            gap: 0.5,
                        }}
                    >
                        <Typography
                            variant="h1"
                            sx={{
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 600,
                                fontSize: { xs: "1.5rem", sm: "2rem", md: "clamp(1.8rem, 2.5vw, 2.5rem)" },
                                color: "#fff",
                                lineHeight: 1.1,
                                letterSpacing: 0.5,
                                textAlign: { xs: "center", sm: "right" },
                                whiteSpace: { sm: "nowrap" },
                                m: 0,
                            }}
                        >
                            {t('careers.title')}
                        </Typography>

                        <Typography
                            sx={{
                                fontFamily: "'Poppins', sans-serif", fontWeight: 300,
                                fontSize: { xs: "0.7rem", sm: "0.85rem", md: "0.90rem" },
                                color: "#fff",
                                opacity: 0.85,
                                lineHeight: 1.4,
                                letterSpacing: 0.3,
                                textAlign: { xs: "center", sm: "right" },
                                whiteSpace: "pre-line",
                            }}
                        >
                            {t('careers.subtitle')}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <section className="lavora-buttons">
                <div className="lavora-buttons-container">
                    {ROLE_ENTRIES.map(({ key, apiValue }) =>
                        <button key={apiValue} className="lavora-btn" onClick={() => handleOpenModal(apiValue)}>
                            {t(key)}
                        </button>
                    )}
                </div>
            </section>
            <ApplicationModal
                open={modalOpen}
                onClose={handleCloseModal}
                role={selectedRole}
                onSubmit={handleSubmitApplication}
            />
            <ConfirmationModal open={showConfirmation} onClose={handleCloseConfirmation}/>
        </div>
    );
};

export default JoinUs;
